import { GlassPanel } from '@/components/glass/GlassPanel';
import { cn } from '@/lib/utils';

/**
 * `<AgentProgressListSkeleton>` — UI-SPEC § 3.4 loading-state placeholder
 * for the JobDetail's agent rows panel.
 *
 * Renders 7 `animate-pulse` placeholder rows matching the AgentProgressRow
 * 5-col anatomy (label · badge · step · message · duration). The skeleton
 * is `aria-hidden` because the parent uses `aria-busy` to communicate the
 * loading state to SR users.
 */
export interface AgentProgressListSkeletonProps {
  className?: string;
}

export function AgentProgressListSkeleton({
  className,
}: AgentProgressListSkeletonProps) {
  return (
    <GlassPanel
      variant="base"
      as="section"
      aria-hidden="true"
      aria-busy="true"
      className={cn('p-4 md:p-6', className)}
    >
      <div className="flex flex-col">
        {Array.from({ length: 7 }).map((_, i) => (
          <div
            key={i}
            className="border-b border-foam-50/10 last:border-b-0 py-3 flex items-center gap-4"
          >
            <div className="h-4 w-32 rounded bg-foam-50/10 animate-pulse" />
            <div className="h-6 w-20 rounded-full bg-foam-50/10 animate-pulse" />
            <div className="h-4 w-12 rounded bg-foam-50/10 animate-pulse" />
            <div className="h-4 flex-1 rounded bg-foam-50/10 animate-pulse" />
            <div className="h-4 w-12 rounded bg-foam-50/10 animate-pulse" />
          </div>
        ))}
      </div>
    </GlassPanel>
  );
}
